import { useEffect, useState } from 'react';
export function useContainerBoundaries(containerRef) {
  var _useState = useState({}),
      boundaries = _useState[0],
      setBoundaries = _useState[1];

  useEffect(function () {
    var updateBoundaries = function updateBoundaries() {
      if (containerRef.current) {
        var _containerRef$current = containerRef.current.getBoundingClientRect(),
            width = _containerRef$current.width,
            left = _containerRef$current.left;

        setBoundaries({
          width: width,
          left: left
        });
      }
    };

    updateBoundaries();
    window.addEventListener('resize', updateBoundaries);
    return function () {
      return window.removeEventListener('resize', updateBoundaries);
    };
  }, [containerRef, setBoundaries]);
  return boundaries;
}